import $ from 'jquery';
import Swiper, { Navigation, Pagination } from 'swiper';
import Swiper, { Autoplay } from 'swiper';
Swiper.use([Autoplay]);

var swiper = new Swiper(".stage-swiper", {
	modules: [Navigation, Pagination],
	autoplay: {
		delay: 7000,
		disableOnInteraction: false,
	},
	loop: true,
	speed: 1000,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

var swiper = new Swiper(".product-swiper", {
	modules: [Navigation, Pagination],
	speed:600,
	pagination: {
	el: ".swiper-pagination",
		clickable:true,
	},
	navigation: {
		nextEl: ".swiper-button-next",
		prevEl: ".swiper-button-prev",
	},
});

var elements = document.getElementsByClassName('zoom');
for(var i= 0; i < elements.length; i++){
    elements[i].addEventListener("click", function(event){
        event.preventDefault();
        document.getElementsByClassName('swiper-slide-active')[0].querySelector('.without-caption').click();
  });  
}